import {RiskModel} from "@/services/ModelRisk/RiskModel";

export class ApproveRiskModelService {
    riskModelId = "3";
    versionId = "8";

    async run(payload) {
        let response = await axios.post(
            `${RiskModel.endpoint}/approve/${this.versionId}`,
            payload
        )

        return response.data;
    }

    async test(riskModelName, riskModelVersion, payload) {
        let response = await axios.post(
            `${RiskModel.endpoint}/${riskModelName}?version=${riskModelVersion}`,
            {
                version: riskModelVersion,
                schema: payload,
                project_id: payload.project_id,
                rfc: payload.rfc
            }
        )

        return response.data;
    }

    async find(projectId, rfc) {
        let response = await axios.get(`${RiskModel.endpoint}/approve/${this.versionId}?project_id=${projectId}&rfc=${rfc}`)
        return response.data;
    }

    async history(projectId, rfc) {
        let response = await axios.get(`${RiskModel.endpoint}/approve/history/${this.riskModelId}?filters[project_id]=${projectId}&filters[rfc]=${rfc}`)
        return response.data;
    }

    async validate(projectId, rfc, payload) {
        let latestApproveModelResult = await this.find(projectId, rfc);
        let newApproveModelResult = await this.run(payload);

        if (latestApproveModelResult.score.toFixed(2) !== newApproveModelResult.score.toFixed(2)) {
            throw {
                state: 'error',
                code: 'different_score',
                message: 'Hubo una actualización en el Modelo de riesgo de Aprobación',
                data: {
                    old: latestApproveModelResult,
                    newest: newApproveModelResult
                }
            };
        }

        return newApproveModelResult;
    }
}
